import React, { useState, useEffect } from "react";
import "./AddNewTrip.css";
import "leaflet/dist/leaflet.css";
import ApiManager from "../../ApiManager/ApiManager";
import ManualAddressForm from "../../components/ManualAddressForm/ManualAddressForm";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getContrastColor } from "../../utils/GetContrastColor";
import { useComponentLoading } from "../../utils/useComponentLoading";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../components/Modal/Modal";
import MapInput from "../../components/MapInput";
import CustomSelect from "../../components/CustomSelect";
import { openFileInNewTab } from "../../utils/fileUtils";

const CompleteTrip = ({ tripInfo, setEditTrip, setRefreshKey }) => {
  const navigate = useNavigate();
  const { withLoading, isLoading: checkLoading, getMessage, getProgress } = useComponentLoading({
    loadData: false,
    getPrice: false,
    submit: false,
    fileView: false
  });

  const [passengers, setPassengers] = useState(tripInfo.passengers || []);
  const [additionalContacts, setAdditionalContacts] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(tripInfo.company.id || {});
  const [driverId, setDriverId] = useState(
    tripInfo.driverTrip?.driver?.id || ""
  );
  const [carId, setCarId] = useState(tripInfo.driverTrip?.car?.id || "");
  const [drivers, setDrivers] = useState([]);
  const [cars, setCars] = useState([]);
  const [carTypes, setCarTypes] = useState([]);
  const [tripTypes, setTripTypes] = useState([]);
  const [tripType, setTripType] = useState(tripInfo.tripType || {});
  const [charges, setCharges] = useState({});
  const [loadingCompanies, setLoadingCompanies] = useState(false);
  const [loadingCarTypes, setLoadingCarTypes] = useState(false);
  const [loadingTripTypes, setLoadingTripTypes] = useState(false);
  const [loadingLables, setLoadingLabels] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]); // State for selected tags
  const [loadingPrice, setLoadingPrice] = useState(false); // State to track loading
  const [showPrices, setShowPrices] = useState(false);
  const [isInputFocusedReporting, setIsInputFocusedReporting] = useState(false);
  const [isInputFocusedDrop, setIsInputFocusedDrop] = useState(false);
  const [items, setItems] = useState([
    { id: "", billingItemId: "", cost: "", notes: "" },
  ]);
  const [billingItems, setBillingItems] = useState([]);
  const [selectedBillingItems, setSelectedBillingItems] = useState(
    tripInfo.billingItems || []
  );
  const [billingItemPayload, setBillingItemPayload] = useState(
    tripInfo.billingItems || []
  );
  const [labels, setLabels] = useState([]); // Stores all labels
  const [selectedLabelIds, setSelectedLabelIds] = useState(
    tripInfo.labels?.map((label) => label.id) || []
  );
  const [cities, setCities] = useState([]);
  const [fromCity, setFromCity] = useState(tripInfo.fromCity || "");
  const [toCity, setToCity] = useState(tripInfo.toCity || "");

  const [garageData, setGarageData] = useState([]);
  const [selectedGarage, setSelectedGarage] = useState(tripInfo.garageId || "");

  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [signatureType, setSignatureType] = useState(null);
  const [isLoadingSignature, setIsLoadingSignature] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [mapReportingAddress, setMapReportingAddress] = useState({
    latitude: tripInfo.reportingLocation?.latitude,
    longitude: tripInfo.reportingLocation?.longitude,
    description: tripInfo.reportingAddress || "",
  });

  const [mapDropAddress, setMapDropAddress] = useState({
    latitude: tripInfo.dropLocation?.latitude,
    longitude: tripInfo.dropLocation?.longitude,
    description: tripInfo.dropAddress || "",
  });

  const handleReportingAddressSelect = (location) => {
    setMapReportingAddress(location);
  };

  const handleDropAddressSelect = (location) => {
    setMapDropAddress(location);
  };

  const fetchFile = async (imagePath) => {
    if (!imagePath) return;

    try {
      // Use the utility function to open the file in a new tab
      await openFileInNewTab(imagePath, (progress) => {
        console.log(`Loading file: ${progress}%`);
      });
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error("Failed to load file. Please try again.");
    }
  };

  console.log("Billing Items before mapping:", selectedBillingItems);


  const handleFileUpload = async (file, index) => {
    if (!file) return;

    try {
      // Delete existing file if there is one
      const existingFile = selectedBillingItems[index]?.imagePath;
      if (existingFile) {
        await deleteStoredFile(existingFile);
      }

      // Get a presigned URL for upload
      const presignedResponse = await ApiManager.storageGetPresignedUploadUrl({
        filename: file.name,
        directory: "images/receipts"
      });

      if (!presignedResponse.ok) {
        throw new Error("Failed to get presigned URL");
      }

      const presignedData = await presignedResponse.json();

      // Upload the file directly to the storage provider
      const uploadResponse = await fetch(presignedData.url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type
        }
      });

      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file");
      }

      // Save metadata after upload using the fileName from the response
      const metadataResponse = await ApiManager.storageSaveMetadata(presignedData.fileName, presignedData.key);

      if (!metadataResponse.ok) {
        throw new Error("Failed to save metadata");
      }

      handleBillingItemChange(index, "imagePath", presignedData.fileName);
      console.log("upload result", presignedData);
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Failed to upload file. Please try again.");
    }
  };

  const deleteStoredFile = async (fileName) => {
    try {
      const response = await ApiManager.storageDeleteFile(fileName);

      if (!response.ok) {
        throw new Error("Failed to delete file");
      }

      console.log(`File ${fileName} deleted successfully`);
    } catch (error) {
      console.error(`Error deleting file ${fileName}:`, error);
    }
  };


  const handleTripTypeChange = (e) => {
    e.preventDefault();
    const selectedTripTypeId = parseInt(e.target.value); // Get the id of the selected trip type
    const selectedType = tripTypes.find(
      (type) => type.id === selectedTripTypeId
    ); // Find the tripType object
    setTripType(selectedType); // Update tripType state with the selected trip type object
  };

  const formatDateTime = (timestamp, type) => {
    if (!timestamp) return "";

    // Create a date object from the timestamp
    const date = new Date(timestamp * 1000);

    // Format the date in IST (UTC+5:30)
    const options = type === "datetime-local"
      ? {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
          timeZone: 'Asia/Kolkata'
        }
      : {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'Asia/Kolkata'
        };

    // Format the date according to the options
    const formattedDate = new Intl.DateTimeFormat('en-CA', options).format(date);

    // For datetime-local, we need to convert from "YYYY-MM-DD, HH:MM" to "YYYY-MM-DDTHH:MM"
    if (type === "datetime-local") {
      return formattedDate.replace(', ', 'T');
    }
    return formattedDate;
  };

  const handleLabelSelect = (e) => {
    const selectedId = parseInt(e.target.value);
    if (!selectedLabelIds.includes(selectedId)) {
      setSelectedLabelIds([...selectedLabelIds, selectedId]);
    }
  };

  const handleBillingItemChange = (index, field, value) => {
    const updatedBillingItemPayload = [...billingItemPayload];
    updatedBillingItemPayload[index][field] = value;
    setBillingItemPayload(updatedBillingItemPayload);

    const updatedBillingItems = [...selectedBillingItems];
    updatedBillingItems[index][field] = value;
    setSelectedBillingItems(updatedBillingItems);
  };

  const removeBillingItem = (index) => {
    const updatedBillingItemPayload = [...billingItemPayload];
    updatedBillingItemPayload[index]["cost"] = 0;
    setBillingItemPayload(updatedBillingItemPayload);

    const updatedBillingItems = selectedBillingItems.filter(
      (_, i) => i !== index
    );
    setSelectedBillingItems(updatedBillingItems);
  };

  const addBillingItem = () => {
    setSelectedBillingItems([
      ...selectedBillingItems,
      { billingItemId: "", cost: "", imagePath: "", notes: "" },
    ]);
    setBillingItemPayload([
      ...billingItemPayload,
      { billingItemId: "", cost: "", imagePath: "", notes: "" },
    ]);
  };

  // Handle label removal
  const handleRemoveLabel = (id) => {
    setSelectedLabelIds(selectedLabelIds.filter((labelId) => labelId !== id));
  };

  // Get loading states with renamed variables
  const isDataLoading = checkLoading('loadData');
  const isPriceLoading = checkLoading('getPrice');
  const isSubmitting = checkLoading('submit');
  const isFileLoading = checkLoading('fileView');
  const loadingMessage = getMessage('loadData') || getMessage('getPrice') || getMessage('submit') || getMessage('fileView') || 'Loading...';
  const loadingProgress = getProgress('loadData') || getProgress('getPrice') || getProgress('submit') || getProgress('fileView');

  // Split data loading into separate useEffects for better performance
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllCompanies(params);
          if (!response.ok) throw new Error("Failed to fetch companies");
          const data = await response.json();
          setCompanies(data || []);
          updateProgress(100);
        }, 'Loading companies...', 30000);
      } catch (error) {
        console.error("Error fetching companies:", error);
        setCompanies([]);
      }
    };
    fetchCompanies();
  }, []);

  useEffect(() => {
    const fetchCarTypes = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getCarType(params);
          if (!response.ok) throw new Error("Failed to fetch car types");
          const data = await response.json();
          setCarTypes(data || []);
          updateProgress(100);
        }, 'Loading car types...', 30000);
      } catch (error) {
        console.error("Error fetching car types:", error);
        setCarTypes([]);
      }
    };
    fetchCarTypes();
  }, []);

  useEffect(() => {
    const fetchTripTypes = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllTripTypes(params);
          if (!response.ok) throw new Error("Failed to fetch trip types");
          const data = await response.json();
          setTripTypes(data || []);
          updateProgress(100);
        }, 'Loading trip types...', 30000);
      } catch (error) {
        console.error("Error fetching trip types:", error);
        setTripTypes([]);
      }
    };
    fetchTripTypes();
  }, []);

  useEffect(() => {
    const fetchLabels = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllLabels(params);
          if (!response.ok) throw new Error("Failed to fetch labels");
          const data = await response.json();
          setLabels(data || []);
          updateProgress(100);
        }, 'Loading labels...', 30000);
      } catch (error) {
        console.error("Error fetching labels:", error);
        setLabels([]);
      }
    };
    fetchLabels();
  }, []);

  useEffect(() => {
    const fetchDriversAndCars = async () => {
      if (
        tripInfo.driverTrip &&
        (tripInfo.tripStatus == "ALLOTTED" || tripInfo.tripStatus == "DISPATCHED")
      ) {
        try {
          await withLoading('loadData', async (updateProgress) => {
            updateProgress(10);

            // Fetch drivers
            const driversParams = new URLSearchParams({
              page_size: 1000,
              page: 1,
            });
            const driversResponse = await ApiManager.getAllDrivers(driversParams);
            if (!driversResponse.ok) throw new Error("Failed to fetch drivers");
            const driversData = await driversResponse.json();
            setDrivers(driversData || []);

            updateProgress(50);

            // Fetch cars
            const carsParams = new URLSearchParams({
              page_size: 1000,
              page: 1,
            });
            const carsResponse = await ApiManager.getAllCars(carsParams);
            if (!carsResponse.ok) throw new Error("Failed to fetch cars");
            const carsData = await carsResponse.json();
            setCars(carsData || []);

            updateProgress(100);
          }, 'Loading drivers and cars...', 30000);
        } catch (error) {
          console.error("Error fetching drivers and cars:", error);
          setDrivers([]);
          setCars([]);
        }
      }
    };
    fetchDriversAndCars();
  }, [tripInfo.driverTrip, tripInfo.tripStatus]);

  useEffect(() => {
    const fetchGarages = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllGarages(params);
          if (!response.ok) throw new Error("Failed to fetch garages");
          const data = await response.json();
          setGarageData(data || []);
          updateProgress(100);
        }, 'Loading garages...', 30000);
      } catch (error) {
        console.error("Error fetching garages:", error);
        setGarageData([]);
      }
    };
    fetchGarages();
  }, []);

  useEffect(() => {
    const fetchBillingItems = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllBillingItems(params);
          if (!response.ok) throw new Error("Failed to fetch billing items");
          const data = await response.json();
          setBillingItems(data || []);
          updateProgress(100);
        }, 'Loading billing items...', 30000);
      } catch (error) {
        console.error("Error fetching billing items:", error);
        setBillingItems([]);
      }
    };
    fetchBillingItems();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        await withLoading('loadData', async (updateProgress) => {
          updateProgress(10);
          const params = new URLSearchParams({
            page_size: 1000,
            page: 1,
          });
          const response = await ApiManager.getAllCities(params);
          if (!response.ok) throw new Error("Failed to fetch cities");
          const data = await response.json();
          setCities(data || []);
          updateProgress(100);
        }, 'Loading cities...', 30000);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]);
      }
    };
    fetchCities();
  }, []);

  const addPassenger = () => {
    setPassengers([...passengers, { name: "", phone: "", email: "" }]);
  };

  const addAdditionalContact = () => {
    setAdditionalContacts([
      ...additionalContacts,
      { name: "", phone: "", email: "" },
    ]);
  };

  const removeAdditionalContact = (index) => {
    const updatedContacts = additionalContacts.filter((_, i) => i !== index);
    setAdditionalContacts(updatedContacts);
  };

  const handleAdditionalContactChange = (index, field, value) => {
    const updatedContacts = [...additionalContacts];
    updatedContacts[index][field] = value;
    setAdditionalContacts(updatedContacts);
  };

  const removePassenger = (index) => {
    const updatedPassengers = passengers.filter((_, i) => i !== index);
    setPassengers(updatedPassengers);
  };

  const handlePassengerChange = (index, field, value) => {
    const updatedPassengers = [...passengers];
    updatedPassengers[index][field] = value;
    setPassengers(updatedPassengers);
  };

  const handleGetPrice = async (event) => {
    setShowPrices(true);
    event.preventDefault();

    const form = event.target.closest("form");
    if (!form) {
      console.error("Form not found");
      return;
    }
    const formData = new FormData(form);

    try {
      await withLoading('getPrice', async (onProgress) => {
        onProgress(30);
        const queryParams = new URLSearchParams({
          trip_type_id: parseInt(formData.get("tripType") ?? tripInfo?.tripType?.id),
          car_type_id: parseInt(formData.get("carType") ?? tripInfo?.carType?.id),
          company_id: company,
          city: fromCity,
        });

        onProgress(60);
        const response = await ApiManager.getCharges(queryParams);
        if (!response.ok) throw new Error("Failed to fetch price");

        onProgress(90);
        const data = await response.json();
        setCharges(data);
        form.querySelector('[name="price"]').value = data?.rates?.base_rates || "";
        form.querySelector('[name="perExKmRate"]').value = data.rates?.extra_km_rates || "";
        form.querySelector('[name="perExTimeUnitRate"]').value =
          tripType && tripType.type === "day-km"
            ? data.rates?.extra_day_rates || ""
            : data.rates?.extra_hr_rates || "";

        onProgress(100);
      }, 'Calculating price...', 30000);
    } catch (err) {
      console.error("Error fetching price:", err);
      form.querySelector('[name="price"]').value = "";
      form.querySelector('[name="perExKmRate"]').value = "";
      form.querySelector('[name="perExTimeUnitRate"]').value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const tripData = Object.fromEntries(formData.entries());

    const reportingAddress = mapReportingAddress.description;
    const dropAddress = mapDropAddress.description;

    // Format date and time to UNIX timestamp
    const scheduledStartTime =
      new Date(tripData.scheduledStartTime).getTime() / 1000;

    const formattedTripData = {
      tripId: tripInfo.tripId,
      companyId: company, // Assuming it's an ID
      fromCity: fromCity,
      toCity: toCity,
      // shortReportingAddress: tripData.shortReportingAddress,
      carType: parseInt(tripData?.carType || tripInfo?.carType?.id), // Assuming it's an ID
      tripType: parseInt(tripData.tripType || tripInfo?.tripType?.id), // Assuming it's an ID
      garageId: parseInt(selectedGarage),
      scheduledStartTime: scheduledStartTime,
      scheduledEndTime: tripData.scheduledEndTime
        ? new Date(tripData.scheduledEndTime).getTime() / 1000
        : null,
      reportingTime: tripData.reportingTime
        ? new Date(tripData.reportingTime).getTime() / 1000
        : null,
      reportingAddress: reportingAddress,
      dropAddress: dropAddress,
      passengers: passengers.filter((p) => p.name || p.phone || p.email),
      ...((tripData.bookedByName ||
        tripData.bookedByPhone ||
        tripData.bookedByEmail) && {
        bookedBy: {
          name: tripData.bookedByName,
          phone: tripData.bookedByPhone,
          email: tripData.bookedByEmail,
        },
      }),
      driverTrip: {
        driverId: parseInt(tripData.driver),
        carId: parseInt(tripData.car),
        departTime: tripData.departTime
          ? new Date(tripData.departTime).getTime() / 1000
          : null,
        startTime: tripData.startTime
          ? new Date(tripData.startTime).getTime() / 1000
          : null,
        garageStartTime: tripData.garageStartTime
          ? new Date(tripData.garageStartTime).getTime() / 1000
          : null,
        endTime: tripData.endTime
          ? new Date(tripData.endTime).getTime() / 1000
          : null,
        garageEndTime: tripData.garageEndTime
          ? new Date(tripData.garageEndTime).getTime() / 1000
          : null,
        startKm: parseFloat(tripData.startKm),
        endKm: parseFloat(tripData.endKm),
        garageStartKm: parseFloat(tripData.garageStartKm),
        garageEndKm: parseFloat(tripData.garageEndKm),
        customerSignature: tripData.customerSignature || "",
        driverNotes: tripData.driverNotes || "",
      },
      // additionalContacts: additionalContacts.filter(c => c.name || c.phone || c.email), // Filter out empty contacts
      labels: selectedLabelIds,
      remarks: tripData.remarks || "",
      ...(((tripInfo.charges && Object.keys(tripInfo.charges).length > 0) ||
        showPrices) && {
        charges: {
          ...charges,
          rates: {
            ...charges.rates,
            base_rates: parseFloat(tripData.price) || 0,
            extra_km_rates: parseFloat(tripData.perExKmRate) || 0,
            ...(tripType?.type === "day-km" && {
              extra_day_rates: parseFloat(tripData.perExTimeUnitRate) || 0,
            }),
            ...(tripType?.type !== "day-km" && {
              extra_hr_rates: parseFloat(tripData.perExTimeUnitRate) || 0,
            }),
          },
        },
      }),
      reportingCoordinates: {
        latitude: mapReportingAddress.latitude,
        longitude: mapReportingAddress.longitude,
      },
      dropCoordinates: {
        latitude: mapDropAddress.latitude,
        longitude: mapDropAddress.longitude,
      },

      TripBillingItems: billingItemPayload
        .filter((item) => item.billingItemId) // Ensure billingItemId exists
        .map((item) => ({
          ...(item.id !== null && item.id !== undefined
            ? { id: Number(item.id) }
            : {}),
          billingItemId: Number(item.billingItemId),
          cost: parseFloat(item.cost),
          imagePath: item.imagePath || "",
          notes: item.notes || "",
        })),
      // operatorNotes: tripData.operatorNotes || "",
      // price: parseFloat(tripData.price) || 0,
      // perExKmRate: parseFloat(tripData.perExKmRate) || 0,
      // perExTimeUnitRate: parseFloat(tripData.perExTimeUnitRate) || 0,
    };

    // Object.keys(formattedTripData).forEach(
    //   (key) =>
    //     (formattedTripData[key] === null ||
    //       formattedTripData[key] === undefined ||
    //       (Array.isArray(formattedTripData[key]) &&
    //         formattedTripData[key].length === 0)) &&
    //     delete formattedTripData[key]
    // );

    console.log("Formatted Trip Data:", formattedTripData);
    try {
      await withLoading('submitTrip', async (onProgress) => {
        onProgress(30);
        const response = await ApiManager.updateTrip(null, formattedTripData);

        onProgress(60);
        if (!response.ok) throw new Error("Failed to update trip");
        const data = await response.json();

        onProgress(80);
        const query = new URLSearchParams({ tripId: data.trip.tripId });
        const closeResponse = await ApiManager.closeTrip(query, null);
        if (!closeResponse.ok) throw new Error("Failed to close duty");

        onProgress(100);
        navigate(`/login/trips/booking-details/${data.trip.tripId}`, {
          state: {
            showToast: true,
            toastMessage: "Trip completed successfully!",
          },
        });
      }, 'Completing trip...', 30000);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to complete trip. Please try again.");
    }
    setEditTrip(0);
    setRefreshKey((prev) => prev + 1);
  };


  const showToast = (message) => {
    toast.success(message, {
      position: "top-center", //toast.POSITION.TOP_CENTER,
      autoClose: 3000, // 3 seconds
    });
  };

  const loadSignature = async (signaturePath) => {
    if (!signaturePath) return;

    try {
      setIsLoadingSignature(true);
      setSignatureUrl(null);
      setSignatureType(null);

      const query = new URLSearchParams({ file_name: signaturePath });
      const response = await ApiManager.getFile(query);

      if (!response.ok) {
        throw new Error("Failed to fetch signature");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const mimeType = response.headers.get("Content-Type");

      setSignatureUrl(url);
      setSignatureType(mimeType);
    } catch (error) {
      console.error("Error fetching signature:", error);
      showToast("Failed to load signature");
    } finally {
      setIsLoadingSignature(false);
    }
  };

  // Load signature when component mounts if it exists
  useEffect(() => {
    if (tripInfo.driverTrip?.customerSignature) {
      loadSignature(tripInfo.driverTrip.customerSignature);
    }

    // Cleanup function to revoke object URL when component unmounts
    return () => {
      if (signatureUrl) {
        URL.revokeObjectURL(signatureUrl);
      }
    };
  }, [tripInfo.driverTrip?.customerSignature]);

  // Determine if any loading state is active
  const isAnyLoading = isDataLoading || isPriceLoading || isSubmitting;

  const handleFileClick = async (fileName) => {
    try {
      // Use the utility function to open the file in a new tab
      await openFileInNewTab(fileName, (progress) => {
        console.log(`Loading file: ${progress}%`);
      });
    } catch (error) {
      console.error("Error fetching file:", error);
      toast.error("Failed to load file. Please try again.");
    }
  };

  // If data is still loading, show only the loading spinner
  if (isDataLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '400px'
      }}>
        <LoadingSpinner
          size="large"
          message={loadingMessage}
          progress={loadingProgress}
          showProgress={true}
        />
      </div>
    );
  }

  return (
    <div className="addNewTrip">
      <form onSubmit={handleSubmit}>
        {tripInfo.driverTrip &&
          (tripInfo.tripStatus == "ALLOTTED" ||
            tripInfo.tripStatus == "DISPATCHED") && (
            <fieldset className="fieldset">
              <legend>Driver and Car Info</legend>
              <div className="row">
                <div className="formGroup">
                  <label>Driver *</label>
                  <select
                    name="driver"
                    required
                    className="input"
                    value={driverId}
                    onChange={(e) => setDriverId(e.target.value)}
                    disabled={tripInfo.tripStatus === "DISPATCHED"}
                  >
                    <option value="" disabled>
                      Select a driver
                    </option>
                    {drivers.map((driver) => (
                      <option key={driver.id} value={driver.id}>
                        {driver.firstName} {driver.lastName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="formGroup">
                  <label>Car *</label>
                  <select
                    name="car"
                    required
                    className="input"
                    value={carId}
                    onChange={(e) => setCarId(e.target.value)}
                    disabled={tripInfo.tripStatus == "DISPATCHED"}
                  >
                    <option value="" disabled>
                      Select a Car
                    </option>
                    {cars.map((car) => (
                      <option key={car.id} value={car.id}>
                        {car.vehicleNo}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </fieldset>
          )}

        {tripInfo.tripStatus != "COMPLETED" && tripInfo.company && (
          <fieldset className="fieldset">
            <legend>Company Info</legend>
            <div className="formGroup">
              <label>Company *</label>
              <CustomSelect
                name="company"
                options={(companies || []).map(company => ({
                  value: company.id,
                  label: company.name
                }))}
                value={company}
                onChange={(selectedOption) => setCompany(selectedOption?.value || "")}
                placeholder="Select a Company"
                isSearchable={true}
                required
              />
            </div>
          </fieldset>
        )}

        {tripInfo.tripStatus != "COMPLETED" && (
          <fieldset className="fieldset">
            <legend>Booked By</legend>
            <div className="row">
              <div className="formGroup">
                <label>Name</label>
                <input
                  type="text"
                  name="bookedByName"
                  className="input"
                  defaultValue={tripInfo?.bookedBy?.name}
                />
              </div>
              <div className="formGroup">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="bookedByPhone"
                  defaultValue={tripInfo?.bookedBy?.phone}
                  className="input"
                  pattern="[0-9]{10}" // For a 10-digit number
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    if (e.target.value.length > 10) {
                      e.target.value = e.target.value.slice(0, 10); // Limit to 10 digits
                    }
                  }}
                />
              </div>
              <div className="formGroup">
                <label>Email</label>
                <input
                  type="email"
                  name="bookedByEmail"
                  defaultValue={tripInfo?.bookedBy?.email}
                  className="input"
                />
              </div>
            </div>
          </fieldset>
        )}

        <fieldset className="fieldset">
          <legend>Passenger Details</legend>
          {(passengers || []).map((passenger, index) => (
            <div key={index} className="passengerRow">
              <div className="formGroup">
                <label>Passenger Name</label>
                <input
                  type="text"
                  value={passenger.name}
                  onChange={(e) =>
                    handlePassengerChange(index, "name", e.target.value)
                  }
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Passenger Phone Number</label>
                <input
                  type="tel"
                  value={passenger.phone}
                  onChange={(e) =>
                    handlePassengerChange(index, "phone", e.target.value)
                  }
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Passenger Email</label>
                <input
                  type="email"
                  value={passenger.email}
                  onChange={(e) =>
                    handlePassengerChange(index, "email", e.target.value)
                  }
                  className="input"
                />
              </div>
              <button
                type="button"
                onClick={() => removePassenger(index)}
                className="removeButton"
              >
                X
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={addPassenger}
            className="addPassengerButton"
          >
            + Add Another Passenger
          </button>
        </fieldset>

        {tripInfo.tripStatus != "COMPLETED" && (
          <fieldset className="fieldset">
            <legend>Address Details</legend>
            <div className="row">
              <div className="formGroup">
                <label>From City *</label>
                <CustomSelect
                  name="fromCity"
                  options={(cities || []).map(city => ({
                    value: city,
                    label: city
                  }))}
                  value={fromCity}
                  onChange={(selectedOption) => setFromCity(selectedOption?.value || "")}
                  placeholder="Select a city"
                  required
                />
              </div>
              <div className="formGroup">
                <label>To City</label>
                <CustomSelect
                  name="toCity"
                  options={(cities || []).map(city => ({
                    value: city,
                    label: city
                  }))}
                  value={toCity}
                  onChange={(selectedOption) => setToCity(selectedOption?.value || "")}
                  placeholder="Select a city"
                  required
                />
              </div>
            </div>

            <div className="mapContainer">
              <div>
                <div>
                  <label>Reporting Address *</label>
                </div>
                <MapInput
                  label="Reporting Address"
                  onAddressSelect={handleReportingAddressSelect}
                  initialValue={mapReportingAddress}
                />
              </div>

              <div>
                <div>
                  <label>Drop Address *</label>
                </div>
                <MapInput
                  label="Drop Address"
                  onAddressSelect={handleDropAddressSelect}
                  initialValue={mapDropAddress}
                />
              </div>
            </div>
          </fieldset>
        )}

        {tripInfo.tripStatus != "COMPLETED" && (
          <>
            <fieldset className="fieldset">
              <legend>Trip Details</legend>
              <div className="row">
                <div className="formGroup">
                  <label>Trip Type *</label>
                  <CustomSelect
                    name="tripType"
                    options={(tripTypes || []).map(tripType => ({
                      value: tripType.id,
                      label: tripType.name
                    }))}
                    value={tripType?.id}
                    onChange={(selectedOption) => {
                      const selectedType = tripTypes.find(
                        (type) => type.id === selectedOption?.value
                      );
                      setTripType(selectedType);
                    }}
                    placeholder="Select a Trip Type"
                    isDisabled={!!tripInfo?.tripType}
                    required
                  />
                </div>
                <div className="formGroup">
                  <label>Car Type *</label>
                  <CustomSelect
                    name="carType"
                    options={(carTypes || []).map(carType => ({
                      value: carType.id,
                      label: carType.name
                    }))}
                    value={tripInfo?.carType}
                    onChange={(selectedOption) => {}}
                    placeholder="Select a Car Type"
                    required
                  />
                </div>
              </div>

              <div className="formGroup">
                <label>Garage</label>
                <CustomSelect
                  name="garage"
                  options={(garageData || []).map(garage => ({
                    value: garage.id,
                    label: garage.address
                  }))}
                  value={selectedGarage}
                  onChange={(selectedOption) => setSelectedGarage(selectedOption?.value || "")}
                  placeholder="Select Garage"
                />
              </div>

              {/* Second Row */}
              <div className="row">
                <div className="formGroup">
                  <label>Scheduled Start Time *</label>
                  <input
                    type="datetime-local"
                    name="scheduledStartTime"
                    defaultValue={formatDateTime(
                      tripInfo?.scheduledStartTime,
                      "datetime-local"
                    )}
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                  />
                </div>
                <div className="formGroup">
                  <label>Scheduled End Time *</label>
                  <input
                    type="datetime-local"
                    name="scheduledEndTime"
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                    defaultValue={formatDateTime(
                      tripInfo?.scheduledEndTime,
                      "datetime-local"
                    )}
                  />
                </div>
                <div className="formGroup">
                  <label>Reporting Time *</label>
                  <input
                    type="datetime-local"
                    name="reportingTime"
                    defaultValue={formatDateTime(
                      tripInfo?.reportingTime,
                      "datetime-local"
                    )}
                    required={tripInfo.tripStatus != "CREATED"}
                    className="input"
                  />
                </div>
              </div>
            </fieldset>

            {/* forth Row */}
            <fieldset className="fieldset">
              <legend>Charges</legend>
              <div className="row">
                {((tripInfo.charges &&
                  Object.keys(tripInfo.charges).length > 0) ||
                    showPrices) && (
                  <>
                    <div className="formGroup">
                      <label>Price</label>
                      <input
                        type="text"
                        name="price"
                        defaultValue={tripInfo?.charges?.rates?.base_rates}
                        className="input"
                      />
                    </div>
                    <div className="formGroup">
                      <label>Per Extra KM rate</label>
                      <input
                        type="text"
                        name="perExKmRate"
                        defaultValue={tripInfo?.charges?.rates?.extra_km_rates}
                        className="input"
                      />
                    </div>
                    <div className="formGroup">
                      <label>
                        {tripType && tripType.type === "day-km"
                          ? "Per Extra Day rate"
                          : "Per Extra Hr rate"}
                      </label>
                      <input
                        type="text"
                        name="perExTimeUnitRate"
                        defaultValue={
                          tripType.type !== "day-km"
                            ? tripInfo?.charges?.rates?.extra_hr_rates
                            : tripInfo?.charges?.rates?.extra_day_rates
                        }
                        className="input"
                      />
                    </div>
                  </>
                )}
                <div className="formGroup getPriceButton">
                  <button
                    type="button"
                    onClick={handleGetPrice}
                    className="btn"
                    disabled={isPriceLoading || isSubmitting}
                    style={{ width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    {isPriceLoading ? (
                      <LoadingSpinner size="small" />
                    ) : (
                      "Get Price"
                    )}
                  </button>
                </div>
              </div>
            </fieldset>
          </>
        )}

        <fieldset className="fieldset">
          <legend>Billing Items</legend>
          {(selectedBillingItems || []).map((selectedBillingItem, index) => (
            <div key={index} className="passengerRow">
              <div className="formGroup">
                <label>Billing Item</label>
                <CustomSelect
                  options={(billingItems || []).map(billingItem => ({
                    value: billingItem.billingItemId,
                    label: billingItem.name
                  }))}
                  value={selectedBillingItem.billingItemId}
                  onChange={(selectedOption) =>
                    handleBillingItemChange(index, "billingItemId", selectedOption?.value || "")
                  }
                  placeholder="Select a billing Item"
                />
              </div>
              <div className="formGroup">
                <label>Cost</label>
                <input
                  type="number"
                  value={selectedBillingItem.cost}
                  onChange={(e) =>
                    handleBillingItemChange(index, "cost", e.target.value)
                  }
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Receipt</label>
                {selectedBillingItem.imagePath && (
                  <button
                    type="button"
                    onClick={() => handleFileClick(selectedBillingItem.imagePath)}
                    className="view-receipt-btn"
                  >
                    View Receipt
                  </button>
                )}
                <input
                  type="file"
                  className="input"
                  onChange={(e) => handleFileUpload(e.target.files[0], index)}
                />
              </div>
              <div className="formGroup">
                <label>Notes</label>
                <input
                  type="textarea"
                  value={selectedBillingItem.notes}
                  onChange={(e) =>
                    handleBillingItemChange(index, "notes", e.target.value)
                  }
                  className="input"
                />
              </div>
              <button
                type="button"
                onClick={() => removeBillingItem(index)}
                className="removeButton"
              >
                X
              </button>
            </div>
          ))}

          <button
            type="button"
            onClick={addBillingItem}
            className="addPassengerButton"
          >
            + Add Billing Item
          </button>
        </fieldset>

        {(tripInfo.tripStatus == "COMPLETED" ||
          tripInfo.tripStatus == "ALLOTTED" ||
          tripInfo.tripStatus == "DISPATCHED") && (
          <fieldset className="fieldset">
            <legend>Driver Trip Details</legend>
            <div className="row">
              <div className="formGroup">
                <label>Depart Time </label>
                <input
                  type="datetime-local"
                  name="departTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.departTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "DISPATCHED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Start Time </label>
                <input
                  type="datetime-local"
                  name="startTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.startTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage Start Time </label>
                <input
                  type="datetime-local"
                  name="garageStartTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.garageStartTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Third Row */}
            <div className="row">
              <div className="formGroup">
                <label>End Time </label>
                <input
                  type="datetime-local"
                  name="endTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.endTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage End Time </label>
                <input
                  type="datetime-local"
                  name="garageEndTime"
                  defaultValue={formatDateTime(
                    tripInfo.driverTrip?.garageEndTime,
                    "datetime-local"
                  )}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Fourth Row */}
            <div className="row">
              <div className="formGroup">
                <label>Start KM </label>
                <input
                  type="text"
                  name="startKm"
                  defaultValue={tripInfo.driverTrip?.startKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>End KM </label>
                <input
                  type="text"
                  name="endKm"
                  defaultValue={tripInfo.driverTrip?.endKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage Start KM </label>
                <input
                  type="text"
                  name="garageStartKm"
                  defaultValue={tripInfo.driverTrip?.garageStartKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
              <div className="formGroup">
                <label>Garage End KM </label>
                <input
                  type="text"
                  name="garageEndKm"
                  defaultValue={tripInfo.driverTrip?.garageEndKm}
                  required={tripInfo.tripStatus != "CREATED"}
                  className="input"
                />
              </div>
            </div>

            {/* Fifth Row */}
            <div className="row">
              <div className="formGroup">
                <label>Customer Signature</label>
                {isLoadingSignature ? (
                  <div className="signature-loading">
                    <LoadingSpinner size="small" message="Loading signature..." />
                  </div>
                ) : signatureUrl ? (
                  <div className="signature-display">
                    <img
                      src={signatureUrl}
                      alt="Customer Signature"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "150px",
                        objectFit: "contain",
                        padding: "5px"
                      }}
                    />
                    <input
                      type="hidden"
                      name="customerSignature"
                      value={tripInfo.driverTrip?.customerSignature || ""}
                    />
                  </div>
                ) : tripInfo.driverTrip?.customerSignature ? (
                  <div className="signature-error">
                    <p>Failed to load signature</p>
                    <button
                      type="button"
                      onClick={() => loadSignature(tripInfo.driverTrip.customerSignature)}
                      className="retry-button"
                    >
                      Retry
                    </button>
                    <input
                      type="hidden"
                      name="customerSignature"
                      value={tripInfo.driverTrip.customerSignature}
                    />
                  </div>
                ) : (
                  <div className="no-signature">
                    <p>No signature available</p>
                    <input
                      type="hidden"
                      name="customerSignature"
                      value=""
                    />
                  </div>
                )}
              </div>
              <div className="formGroup">
                <label>Driver Notes</label>
                <textarea
                  name="driverNotes"
                  defaultValue={tripInfo.driverTrip?.driverNotes}
                  className="input"
                ></textarea>
              </div>
            </div>
          </fieldset>
        )}

        <div className="row">
          <div className="formGroup">
            <label>Remarks</label>
            <textarea
              name="remarks"
              defaultValue={tripInfo?.remarks}
              className="input remarks"
              rows="3"
            />
          </div>
          <div className="formGroup">
            <label>Operator Notes</label>
            <textarea
              name="operatorNotes"
              defaultValue={tripInfo?.operatorNotes}
              className="input operatorNotes"
              rows="3"
            />
          </div>
        </div>

        <fieldset className="fieldset">
          <legend>Labels</legend>
          <div className="formGroup">
            <label>Select Labels</label>
            <CustomSelect
              options={(labels || []).map(label => ({
                value: label.id,
                label: label.name
              }))}
              value=""
              onChange={(selectedOption) => {
                if (selectedOption?.value && !selectedLabelIds.includes(selectedOption.value)) {
                  setSelectedLabelIds([...selectedLabelIds, selectedOption.value]);
                }
              }}
              placeholder="Select a Label"
            />

            {/* Display selected labels */}
            {selectedLabelIds.length > 0 && (
              <div className="selectedLabels">
                {selectedLabelIds.map((id) => {
                  const label = labels.find((label) => label.id === id);
                  if (!label) return null;

                  const backgroundColor = label.color;
                  const textColor = getContrastColor(backgroundColor);

                  return (
                    <div
                      key={id}
                      className="selectedLabel"
                      style={{ backgroundColor: label.color, color: textColor }}
                    >
                      {label.name}
                      <button
                        style={{ color: textColor }}
                        onClick={() => handleRemoveLabel(id)}
                      >
                        x
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </fieldset>

        {/* Submit Button */}
        <div className="form-actions">
          <button
            type="submit"
            className="submit-button"
          >
            {isSubmitting ? (
              <LoadingSpinner size="small" />
            ) : (
              "Complete Trip"
            )}
          </button>
        </div>
      </form>

      {isModalOpen && showFile && (
        <div className="file-container">
          <Modal isOpen={isModalOpen} onClose={() => setModalOpen(false)}>
            {isFileLoading ? (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '500px',
                width: '100%'
              }}>
                <LoadingSpinner
                  overlay={false}
                  message={getMessage('fileView') || "Loading file..."}
                  progress={getProgress('fileView')}
                  showProgress={true}
                />
              </div>
            ) : fileUrl ? (
              <>
                {fileType === "application/pdf" ? (
                  <iframe src={fileUrl} width="100%" height="500px"></iframe>
                ) : (
                  <img
                    src={fileUrl}
                    alt="Fuel Receipt"
                    style={{
                      maxWidth: "40%",
                      objectFit: "contain",
                      display: "block",
                      margin: "auto",
                    }}
                  />
                )}
              </>
            ) : (
              <p>Loading file...</p>
            )}
          </Modal>
        </div>
      )}
    </div>
  );
};

export default CompleteTrip;
